import elemento from '../../assets/elemento.png';

const fakeData = {
    ranking: [
        {
            rank: 1,
            name: 'Maria Silveira',
            position: 'Full stack developer',
            image: elemento,
            github: 'https://github.com',
            linkedin: 'https://linkedin.com',
            score: '95',
        },
        {
            rank: 2,
            name: 'Marcos Paliari',
            position: 'Full stack developer',
            image: elemento,
            github: 'https://github.com',
            linkedin: 'https://linkedin.com',
            score: '88',
        },
        {
            rank: 3,
            name: 'Ana Monteiro',
            position: 'Full stack developer',
            image: elemento,
            github: 'https://github.com',
            linkedin: 'https://linkedin.com',
            score: '84',
        },
        {
            rank: 4,
            name: 'Julio Souza',
            position: 'Full stack developer',
            image: elemento,
            github: 'https://github.com',
            linkedin: 'https://linkedin.com',
            score: '80',
        },
        {
            rank: 5,
            name: 'Luana Costa',
            position: 'Full stack developer',
            image: elemento,
            github: 'https://github.com',
            linkedin: 'https://linkedin.com',
            score: '76',
        },
        {
            rank: 6,
            name: 'Laura Monteiro Oliveira',
            position: 'Full stack developer',
            image: elemento,
            github: 'https://github.com',
            linkedin: 'https://linkedin.com',
            score: '73',
        },
        {
            rank: 7,
            name: 'Junior Correia',
            position: 'Full stack developer',
            image: elemento,
            github: 'https://github.com',
            linkedin: 'https://linkedin.com',
            score: '69',
        },
        {
            rank: 8,
            name: 'Laura Monteiro Oliveira',
            position: 'Full stack developer',
            image: elemento,
            github: 'https://github.com',
            linkedin: 'https://linkedin.com',
            score: '68',
        },
        {
            rank: 9,
            name: 'Ana Monteiro',
            position: 'Full stack developer',
            image: elemento,
            github: 'https://github.com',
            linkedin: 'https://linkedin.com',
            score: '62',
        },
        {
            rank: 10,
            name: 'Junior Correia',
            position: 'Full stack developer',
            image: elemento,
            github: 'https://github.com',
            linkedin: 'https://linkedin.com',
            score: '57',
        },
    ],
};

export default fakeData;
